import { useTheme } from '@/providers/ThemeProvider';
import { cn } from '@/utils/cn';

type BrandMarkProps = {
  compact?: boolean;
};

export function BrandMark({ compact = false }: BrandMarkProps) {
  const theme = useTheme();

  return (
    <div className={cn('brand-mark', compact && 'brand-mark--compact')}>
      <span className="brand-mark__badge">{theme.brandMark}</span>
      <div>
        <p className="brand-mark__title">{theme.brandName}</p>
        <p className="brand-mark__subtitle">Operations console</p>
      </div>
    </div>
  );
}
